import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "src/types/authTenant.types";

const initialState: AuthState = {
  login: {
    loading: false,
    data: null,
    error: null,
  },
  isAuthenticated: false,
  user: {
    loading: false,
    data: null,
    error: null,
  },
  editUser: {
    loading: false,
    data: null,
    error: null,
  },
};

const authSlice = createSlice({
  name: "authTenant",
  initialState,
  reducers: {
    loginRequest: (
      state,
      action: PayloadAction<{ email: string; password: string }>
    ) => {
      state.login.loading = true;
      state.login.data = null;
      state.login.error = null;
    },
    loginRequestSuccess: (state, action: PayloadAction<AuthState["user"]>) => {
      state.isAuthenticated = true;
      state.login.loading = false;
      state.login.data = action.payload;
      state.login.error = null;
    },
    loginRequestError: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.login.loading = false;
      state.login.data = null;
      state.login.error = action.payload;
    },

    getUserDetailsRequest: (state, action: PayloadAction) => {
      state.user.loading = true;
      state.user.data = null;
      state.user.error = null;
    },
    getUserDetailsSuccess: (
      state,
      action: PayloadAction<AuthState["user"]>
    ) => {
      state.isAuthenticated = true;
      state.user.loading = false;
      state.user.data = action.payload.data;
      state.user.error = null;
    },
    getUserDetailsError: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.user.loading = false;
      state.user.data = null;
      state.user.error = action.payload;
    },

    // edit tenant user actions
    editUserRequest: (
      state,
      action: PayloadAction<{
        firstName: string;
        lastName?: string;
        email: string;
        password?: string;
      }>
    ) => {
      state.editUser.loading = true;
      state.editUser.data = null;
      state.editUser.error = null;
    },
    editUserSuccess: (state, action: PayloadAction<any>) => {
      state.editUser.loading = false;
      state.editUser.data = action.payload;
      state.editUser.error = null;
    },
    editUserError: (state, action: PayloadAction<string>) => {
      state.editUser.loading = false;
      state.editUser.data = null;
      state.editUser.error = action.payload;
    },
    resetEditUser: (state) => {
      state.editUser.loading = false;
      state.editUser.data = null;
      state.editUser.error = null;
    },

    // setUser: (state, action: PayloadAction<AuthState["user"]>) => {
    //   state.user = action.payload;
    // },

    logout: (state) => {
      state.isAuthenticated = false;
      state.user.data = null;
      state.login.loading = false;
      state.login.data = null;
      state.login.error = null;
    },
  },
});

export const {
  // Login actions
  loginRequest,
  loginRequestSuccess,
  loginRequestError,

  // Get User Details Actions
  getUserDetailsRequest,
  getUserDetailsSuccess,
  getUserDetailsError,

  // Edit User Actions
  editUserRequest,
  editUserSuccess,
  editUserError,
  resetEditUser,

  // user actions
  // setUser,

  // Logout action
  logout,
} = authSlice.actions;
export default authSlice.reducer;
